import { useState } from 'react'
import { AZWellnessCarousel, HubspotBrochureDownload } from '.'

const AZWellnessGuide = (props) => {
  return (
    <>
      <section className="contentmainN ptb0">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>Why you need to know more about corporate wellness programs.</li>
                  <li>Vantage Fit's curated A-Z wellness challenge ideas.</li>
                  <li>How you can teach your employees the basics of executing the correct form.</li>
                  <li>Physical and mental health benefits of doing the challenge.</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <AZWellnessCarousel />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="5f425bb7-20c4-4dc4-8f8d-cac9b7e403e3" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AZWellnessGuide
